import { motion } from 'framer-motion';
import { ShareNetwork, CheckCircle, XCircle } from '@phosphor-icons/react';

import { useSharePoll } from '@/hooks';

import styles from './QuizResult.module.css';

interface QuizResultProps {
    isCorrect: boolean;
    correctOptionText: string;
    userSlug: string;
    pollSlug: string;
    pollTitle: string;
}

export function QuizResult({ isCorrect, correctOptionText, userSlug, pollSlug, pollTitle }: QuizResultProps) {
    const { share } = useSharePoll();

    return (
        <motion.div
            className={`${styles.container} ${isCorrect ? styles.correct : styles.incorrect}`}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ type: 'spring', stiffness: 300, damping: 20 }}
        >
            <motion.div
                className={styles.iconWrapper}
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ delay: 0.2, type: 'spring', stiffness: 400 }}
            >
                {isCorrect
                    ? <CheckCircle size={36} weight="duotone" className={styles.correctIcon} />
                    : <XCircle size={36} weight="duotone" className={styles.incorrectIcon} />
                }
            </motion.div>

            <h3 className={styles.title}>
                {isCorrect ? '¡Acertaste!' : 'Incorrecto'}
            </h3>

            {!isCorrect && (
                <p className={styles.answer}>
                    La respuesta correcta era: <strong>{correctOptionText}</strong>
                </p>
            )}

            <button
                className={styles.shareBtn}
                onClick={() => share(userSlug, pollSlug, pollTitle)}
            >
                <ShareNetwork size={16} weight="bold" />
                Compartir resultado
            </button>
        </motion.div>
    );
}
